import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

// Fetch function to support pagination and search
const fetchLeagueMembers = async (
  leagueId,
  page,
  limit,
  search,
  getAccessTokenSilently
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = await getAccessTokenSilently();

  const { data } = await axios.get(
    `${apiUrl}/api/league/league-members/${leagueId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        page, // Page number for pagination
        limit, // Limit for pagination
        search, // Search term for username/email
      },
    }
  );

  return data;
};

// Updated hook to include search functionality
export const useLeagueMembers = (leagueId, page, limit, search) => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    ["leagueMembers", leagueId, page, limit, search], // Include search in the query key
    () =>
      fetchLeagueMembers(leagueId, page, limit, search, getAccessTokenSilently),
    {
      enabled: !!leagueId, // Fetch only if leagueId is provided
      keepPreviousData: true, // Preserve previous data while fetching new data
    }
  );
};
